import { productsState } from '@/states/products.state';
import { atom } from 'jotai';

/**
 * Derived from productsState so column visibility stays in sync with the data
 * we render. Using filteredFlatRowsState (updated in useEffect after table render)
 * caused header/body misalignment when the column appeared or disappeared.
 */
export const hasShopifyIdsInCurrentViewState = atom((get) => {
  const products = get(productsState);
  return products.some((p) => Boolean(p.activeVersion.shopifyVariantId));
});
